import { ETopBetsStatus, ITopBetsState } from './types';

export function initDefaultState(): ITopBetsState {
  return {
    status: ETopBetsStatus.initial,
    errorCode: null,
    requestDateTime: new Date().toISOString(),
    leaders: [],
    serpUrl: null,
  };
}
